module.exports = __webpack_public_path__ + "static/media/xmListen.fde14d1b.png";